document.addEventListener('DOMContentLoaded', () => {
    const targetSection = document.querySelector('.cb-list');
    if (targetSection) {
        let isInView = false;
        let lastScrollTop = 0;
        
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    isInView = true;
                } else {
                    isInView = false;
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        });

        observer.observe(targetSection);

        document.addEventListener('scroll', (e) => {
            if (window.innerWidth >= 768) return;
            let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScrollTop > lastScrollTop) {
                if (isInView) {
                    targetSection.scrollLeft += 5;
                }
            }
            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        });
    };
});